import { render, staticRenderFns } from "./VacationCarryOverRequestActivityDialog.vue?vue&type=template&id=52a04e23&"
import script from "./VacationCarryOverRequestActivityDialog.vue?vue&type=script&lang=ts&"
export * from "./VacationCarryOverRequestActivityDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports